// extracted by mini-css-extract-plugin
export default {"root":"adaptivecontainer_root__3VcvD"};